module.exports = __webpack_public_path__ + "img/rank_3.d514482a.png";